import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../api";

/**
 * Whether the store has switched a service off, for the screens that hide it.
 * Unknown — still loading, or no Settings access to read it — is "on": the
 * server refuses anyway.
 */
export function useServiceOff(storeId: string): (code: string) => boolean {
	const api = useApi();
	const switches = useQuery({
		queryKey: ["portal", storeId, "services"] as const,
		queryFn: ({ signal }) => api.getPortalServiceSwitches({ signal }),
		enabled: storeId !== "",
		retry: false,
	});
	return (code) => {
		const data = switches.data;
		if (data === undefined) {
			return false;
		}
		if (code === "DELIVERY") {
			return data.deliveryOn === false;
		}
		return (data.services ?? []).some((s) => s.service.code === code && !s.on);
	};
}
